import axios from "axios";
import { API_DOMAIN } from "../constants";
import useSnackbar from "../Snackbar/UseSnackbar";

export const useCommonApiCall = () => {
    const { ErrorSnackbar } = useSnackbar();

    const CommonApiCall = async (value, endPoint, type = "post") => {
        try {
            let response;
            if (type === "get") {
                response = await axios.get(`${API_DOMAIN}/${endPoint}`, { params: value });
            } else {
                response = await axios[type](`${API_DOMAIN}/${endPoint}`, value);
            }

            const { status = true, message = "Success", data } = response.data || {};

            // ✅ only handle success via return
            if (status) return { status, message, data };

            // ❌ handle error here only (notify + return)
            ErrorSnackbar(message || "Unknown error");
            return { status: false, message, data };
        } catch (error) {
            const errMsg =
                error.response?.data?.message ||
                error.message ||
                "Network error";
            ErrorSnackbar(errMsg);
            return { status: false, message: errMsg, data: null };
        }
    };

    return { CommonApiCall };
};
